<template>
  <div class="check-in-card" :class="statusClass">
    <div class="card-day">วันที่ {{ day }}</div>
    <div class="card-icon">{{ statusIcon }}</div>
    <div class="card-amount">฿ {{ formatNumber(amount) }}</div>
    <div class="card-status">{{ statusText }}</div>
  </div>
</template>

<script>
export default {
  name: 'CheckInCard',
  props: {
    day: {
      type: Number,
      required: true,
      validator: value => value >= 1 && value <= 3
    },
    status: {
      type: String,
      required: true,
      validator: value => ['completed', 'active', 'pending'].includes(value)
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusClass() {
      return `status-${this.status}`
    },
    statusIcon() {
      switch (this.status) {
        case 'completed':
          return '✓'
        case 'active':
          return '⏳'
        case 'pending':
        default:
          return '-'
      }
    },
    statusText() {
      switch (this.status) {
        case 'completed':
          return 'สำเร็จ'
        case 'active':
          return 'ฝากวันนี้'
        case 'pending':
        default:
          return 'รอดำเนินการ'
      }
    }
  },
  methods: {
    formatNumber(num) {
      return new Intl.NumberFormat('th-TH').format(num)
    }
  }
}
</script>

<style lang="scss" scoped>
.check-in-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 12px 8px;
  backdrop-filter: blur(10px);
  min-height: 100px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;

  @media (min-width: 768px) {
    padding: 16px 12px;
    min-height: 110px;
  }
}

.card-day {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 4px;

  @media (min-width: 768px) {
    font-size: 13px;
  }
}

.card-icon {
  font-size: 24px;
  margin: 8px 0;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    font-size: 28px;
    height: 36px;
  }
}

.card-amount {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  margin: 4px 0;

  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.card-status {
  font-size: 10px;
  font-weight: 400;
  margin-top: 4px;

  @media (min-width: 768px) {
    font-size: 11px;
  }
}

// Status-specific styles
.status-completed {
  background: rgba(40, 167, 69, 0.15);
  border: 1px solid rgba(40, 167, 69, 0.3);

  .card-icon {
    color: #28a745;
  }

  .card-status {
    color: #28a745;
  }
}

.status-active {
  background: rgba(255, 204, 0, 0.1);
  border: 1px solid rgba(255, 204, 0, 0.3);
  animation: pulse-border 2s ease-in-out infinite;

  .card-icon {
    color: #ffcc00;
  }

  .card-status {
    color: #ffcc00;
  }
}

.status-pending {
  .card-icon {
    color: rgba(255, 255, 255, 0.3);
  }

  .card-amount {
    color: rgba(255, 255, 255, 0.5);
  }

  .card-status {
    color: rgba(255, 255, 255, 0.5);
  }
}

// Pulse animation for active card
@keyframes pulse-border {
  0%,
  100% {
    border-color: rgba(255, 204, 0, 0.3);
    box-shadow: 0 0 0 rgba(255, 204, 0, 0);
  }
  50% {
    border-color: rgba(255, 204, 0, 0.6);
    box-shadow: 0 0 8px rgba(255, 204, 0, 0.3);
  }
}
</style>
